import type { StaticParamsBase } from '../types/common'
import { useAppContext } from './useAppContext'

export function useDynamicParams<TDynamicParams extends object>(): TDynamicParams {
  const { paramsDynamic } = useAppContext<StaticParamsBase, TDynamicParams>()
  return { ...paramsDynamic }
}
